import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-detail-info.module.scss";
import VelavuButton from "../../../../elements/velavu-button";
import { FloorInputInfo } from "../floor-input/floor-input-info";
import {
	FloorEditDataState,
	FloorEditState,
} from "../../../../state/floor/floor-edit-state";
import { makeStyleable } from "../../../../helper/icon-helper";
import IconCheckCircleFilled from "../../../../dynamicicons/icon-check-circle-filled";
import VelavuSavedIndicator from "../../../../elements/velavu-saved-indicator";

export interface FloorDetailInfoProps {
	state: FloorEditState;
}

export function FloorDetailInfo(props: FloorDetailInfoProps) {
	const { t } = useTranslation();
	const existingFloors = useMemo(() => {
		//Return all floors except the one we're editing
		if (
			!props.state.site ||
			!props.state.site.floors ||
			!props.state.floor
		) {
			return [];
		}
		const floorID = props.state.floor.id;
		return props.state.site.floors.filter((floor) => {
			return floor.id !== floorID;
		});
	}, [props.state.site, props.state.floor]);

	const setInfo = props.state.setInfo;

	const setLevel = useCallback(
		(level: number) => {
			setInfo((prev) => ({
				...prev,
				level,
			}));
		},
		[setInfo],
	);

	const setName = useCallback(
		(name: string) => {
			setInfo((prev) => ({
				...prev,
				name,
			}));
		},
		[setInfo],
	);

	return (
		<div className={styles.content}>
			<FloorInputInfo
				existingFloors={existingFloors}
				level={props.state.info.level}
				onChangeLevel={setLevel}
				name={props.state.info.name}
				onChangeName={setName}
			/>

			{props.state.dataState === FloorEditDataState.Saved ? (
				<VelavuSavedIndicator fullWidth />
			) : (
				<VelavuButton
					label={t("common.save")}
					disabled={
						props.state.dataState === FloorEditDataState.Idle ||
						props.state.dataState === FloorEditDataState.Saving
					}
					loadingIndicator={
						props.state.dataState === FloorEditDataState.Saving
					}
					fullWidth
					onClick={props.state.submit}
				/>
			)}
		</div>
	);
}
